import { createSelector } from "@ngrx/store";
import { IAppState } from "../state/app.state";
import { IContractState } from "../state/contract.state";
import { ContractStatusEnum } from "@edp-enums/contract-status-enum";
import { IContractFilter, IFilteredContractList } from "@edp-components/edp-contract/edp-contract.model";

const contractSelector = (state: IAppState) => state.contracts;
const filtersSelector = (state: IAppState) => state.contracts.filters;

export const getAllContracts = createSelector(contractSelector, (state: IContractState) => state.contracts);

export const getContracts = createSelector(contractSelector, (state: IContractState) =>
    state.contracts.filter(
        contract =>
            contract.Status === ContractStatusEnum.ACTIVE ||
            contract.Status === ContractStatusEnum.IN_ACTIVATION ||
            contract.Status === ContractStatusEnum.INACTIVE
    )
);

export const getActivedContracts = createSelector(contractSelector, (state: IContractState) =>
    state.contracts.filter(contract => contract.Status === ContractStatusEnum.ACTIVE)
);

export const verifyAllContractHasPack = createSelector(contractSelector, (state: IContractState) => {
    // const activeContracts = state.contracts.filter(contract => contract.Status === ContractStatusEnum.ACTIVE);
    const hasPack = state.contracts.some(contract => !!contract.HasPack && !contract.HasPackInActivation);
    return hasPack;
});

export const verifyAllContractHasPackInActivation = createSelector(contractSelector, (state: IContractState) => {
    const hasPack = state.contracts.some(contract => !!contract.HasPack && !contract.HasPackInActivation);
    if (!!hasPack) {
        return false;
    }
    const HasPackInActivation = state.contracts.some(contract => !!contract.HasPackInActivation);
    return HasPackInActivation;
});

export const getContract = createSelector(contractSelector, (state: IContractState) => state.selectedContract.data);

export const getContractAPIError = createSelector(contractSelector, (state: IContractState) => state.selectedContract.lastAPIError);

export const isSingleContract = createSelector(contractSelector, (state: IContractState) => state.isSingleContract);

export const getTotalDiscount = createSelector(contractSelector, (state: IContractState) => state.totalDiscount);

export const getPendingContracts = createSelector(contractSelector, (state: IContractState) => state.pendingContracts);

export const getPartnerInfo = createSelector(contractSelector, (state: IContractState) => state.partnerInfo.data);

export const getPartnerInfoAPIError = createSelector(contractSelector, (state: IContractState) => state.partnerInfo.lastAPIError);

export const getPaymentReference = createSelector(contractSelector, (state: IContractState) => state.paymentReference);

export const getPaymentReferenceError = createSelector(contractSelector, (state: IContractState) => state.paymentReferenceError);

export const getTotalDiscountsByContact = createSelector(contractSelector, (state: IContractState) => state.totalDiscountsByContract);

export const getContractDetails = createSelector(contractSelector, (state: IContractState) => state.selectedContractDetails.data);

export const getContractDetailsAPIError = createSelector(
    contractSelector,
    (state: IContractState) => state.selectedContractDetails.lastAPIError
);

export const getComplementaryInfo = createSelector(contractSelector, (state: IContractState) => state.complementaryInfo);

export const getUrlToRedirect = createSelector(contractSelector, (state: IContractState) => state.urlToRedirect);

export const contractsGetFilters = createSelector(contractSelector, (state: { filters: IContractFilter[] }) => state.filters);

export const getSelectedOrFirstContract = createSelector(contractSelector, (state: IContractState) => {
    if (state.contracts.length) {
        return state.selectedContract.data || state.contracts.filter(contract => contract.isActivo())[0];
    }
});

export const filteredContracts = createSelector(
    filtersSelector,
    contractSelector,
    (filters: IContractFilter[], contracts: IContractState) => {
        if (filters && contracts) {
            if (filters.length > 0) {
                const result: IFilteredContractList = {
                    filtered: contracts.contracts,
                    total: contracts.contracts.length,
                };

                let selectedFilter: number[] = [];
                filters.forEach(filter => {
                    selectedFilter = filter.options.some(opt => opt.selected) ? [...selectedFilter, filter.id] : [...selectedFilter];
                });

                if (selectedFilter.length === 0) {
                    return result;
                }

                const _energyFiltered = selectedFilter.some(ftrId => ftrId === 1);
                const _statusFiltered = selectedFilter.some(ftrId => ftrId === 2);

                result.filtered = contracts.contracts.filter(contract => {
                    let contractValid = 0;
                    filters.forEach(flt => {
                        if (_energyFiltered && flt.id === 1) {
                            contractValid = flt.options.some(opt => opt.selected && opt.value === contract.getType())
                                ? ++contractValid
                                : contractValid;
                        }
                        if (_statusFiltered && flt.id === 2) {
                            contractValid = flt.options.some(
                                opt =>
                                    opt.selected &&
                                    ((opt.value === "active" && (contract.isActivo() || contract.isInActivation())) ||
                                        (opt.value === "inactive" && contract.isInactive()))
                            )
                                ? ++contractValid
                                : contractValid;
                        }
                    });
                    return contractValid === selectedFilter.length;
                });

                return result;
            }
        } else {
            return null;
        }
    }
);

export const getCheckUpCards = createSelector(contractSelector, (state: IContractState) => state.checkUpCards);

export const getBusinessAgrements = createSelector(contractSelector, (state: IContractState) => state.businessAgrements);

export const getUpdateBusinessAgrementsStatus = createSelector(
    contractSelector,
    (state: IContractState) => state.updateBusinessAgrementsStatus
);

export const getAddressList = createSelector(contractSelector, (state: IContractState) => state.addressList);

export const getTariffsMappings = createSelector(contractSelector, (state: IContractState) => state.tariffsMapping);

export const getNewContractTariffs = createSelector(contractSelector, (state: IContractState) => state.newTariffs);

export const getPacks = createSelector(contractSelector, (state: IContractState) => state.packs);

export const getPack = createSelector(contractSelector, (state: IContractState) => state.selectedPack);

export const getDiscounts = createSelector(contractSelector, (state: IContractState) => state.discounts);

export const getAlerts = createSelector(contractSelector, (state: IContractState) => state.alerts);

export const getContractedServices = createSelector(contractSelector, (state: IContractState) => state.contractedServices);

export const getWallBoxService = createSelector(contractSelector, (state: IContractState) => state.wallboxService);
